const moment = require('moment-timezone');

const zone = 'Asia/Hong_Kong';

export function expiredQuotationISOString() {
  return moment.tz(moment().subtract(6, 'months').toISOString(), zone).format();
}

export function todayMomentISOString() {
  return moment.tz(moment().toISOString(), zone).format();
}

export function momentToISOString(input) {
  return moment.tz(input.toISOString(), zone).format();
}

export function momentEndDateToISOString(input) {
  return moment.tz(input.toISOString(), zone).endOf('day').format();
}

export function momentSetHKTimezone(input) {
  return moment.tz(input, zone)
}

export function momentSetHKTimezoneWithFormat(input, format) {
  return moment.tz(input, zone).format(format)
}

export function coverNoteTodayAdd30Day() {
  const newDays = moment().add(29, 'days')
  return moment.tz(newDays.toISOString(), zone).format();
}

export function quotationTodayAdd1Year() {
  const newDays = moment().add(1, 'years').subtract(1, 'days');
  return moment.tz(newDays.toISOString(), zone).format();
}

export function coverNoteMomentAdd30Day(input) {
  const newDays = input.add(29, 'days')
  return moment.tz(newDays.toISOString(), zone).format();
}

export function quotationMomentAdd1Year(input) {
  const newDays = input.add(1, 'years').subtract(1, 'days');
  return moment.tz(newDays.toISOString(), zone).format();
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js